<template>
  <div class="discountCoupon">
    <div class="clear">
      <h2 class="paging-title">优惠券</h2>
    </div>
    <div class="tab-wrapper">
      <ul class="tab-hd">
        <li 
          v-for="(item,index) in tabs" 
          :key="index" 
          :class="{'on':listType==item.CouponsTypeId}"
          @click="tabClick(item.CouponsTypeId)"
        >{{item.CouponsTypeName}}</li>
      </ul>
      <div class="btn-group">
        <span class="btn-text" @click="$router.push('/center/suppliedCoupon')">待领取</span>
        <span class="btn-text" @click="$router.push('/center/couponRecord')">历史记录</span>
      </div>
    </div>
    <div class="coupon-wrwapper">
      <span class="btn-rule" @click="isShowCouponRule=true">使用规则</span>
      <ul class="list">
        <li v-for="(item,index) in couponList" :key="index">
          <div class="dt">
            <div class="type-name">
              <div>
                {{item.CouponTypeStr}}
                <template v-if="item.CouponType !=3 || (item.CouponType ==1 && item.UseScope!=5)">
                  —{{item.UseScopeStr}}
                </template>
              </div>
              <template v-if="item.CouponType !=3">
                {{item.UsePermissionStr}}
              </template>
            </div>
            <div class="count" v-if="item.CouponMode ==1">¥{{item.FullReduceOffAmount}}</div>
            <div class="count" v-if="item.CouponMode ==2">{{item.OffAmount}} <span class="unit">折</span></div>
            <div class="count" v-if="item.CouponMode ==3">¥{{item.OffAmount}}</div>
            <div class="desc">{{item.CouponTypeStr}}</div>
            <span class="expire" v-if="item.IsDisplayDateIco">{{item.EffectivityEndTime}}</span>
          </div>
          <div class="dd">
            <div class="title">{{item.CouponModeStr}} <span class="mark" v-if="item.title">{{item.title}}</span></div>
            <span class="time" >{{item.EffectivityEndTime}}</span>
            <button class="btn-default" @click="open(item)">去使用</button>
          </div>
        </li>
      </ul>
      <i class="icon-empty" v-if="couponList.length==0"></i>
    </div>
    <coupon-rule :show="isShowCouponRule" @close="isShowCouponRule=false"></coupon-rule>
  </div>
</template>
<script>
import couponRule from '@/components/couponRule.vue'
import {
    GetUserCouponList,
    GetCouponsType,
} from '@/scripts/api.js'
import {mapState} from 'vuex'
import {p_origin,peixun} from '@/scripts/util.js'
export default {
  components:{
    couponRule
  },
  data(){
    return{
      tabs:[],
      listType:1,
      couponList:[],
      isShowCouponRule:false,
    }
  },
	computed:{
		...mapState({
			userInfo:state=>state.userInfo,
		})
	},
  filters:{
    formatTime(value){
      if(value){
        return value.substr(0,10);
      }
      return '';
    }
  },
  created() {
    this.loadTypes();
  },
  methods: {
    tabClick(id){
      this.listType=id;
      this.loadCoupon(this.listType);
    },
    loadTypes(){
      GetCouponsType({platform:'pcweb',}).then(r=>{
        if(r.Result==1){
          this.tabs=r.Data ||[];
          if(this.tabs.length){
            let id=this.tabs[0].CouponsTypeId;
            this.tabClick(id);
          }
          
        }else{
          this.$toast(r.Message);
        }
      })
    },
    //获取用户优惠券
    loadCoupon(type){
      this.couponList=[];
      let params={
        PageNum:1,
        PageSize:999,
        CouponType:type,
        CouponStatus:1,
        platform:'pcweb',
      }
      if(this.userInfo && this.userInfo.LoginAccountType==1){
        params['UserId']=this.userInfo.LoginAccountId;
      }else if(this.userInfo && this.userInfo.LoginAccountType==2){
        params['CompanyId']=this.userInfo.LoginAccountId;
      }else{
        return;
      }
      GetUserCouponList(params).then(r=>{
        if(r.Result==1){
          this.couponList=r.Data || [];
        }else{
          this.$toast(r.Message);
        }
      })
    },
    //去使用
    open(item){
      if(item.CouponType==1 || item.CouponType ==3){
        //发单和通用优惠券去首页
        this.$router.push('/home');
      }else{
        //去培训课程
        let url=peixun+'/GongKongSuPai/Train/TrainIndex';
        window.open(url,'_blank');
      }
    }
  },
}
</script>
<style lang="scss">
.discountCoupon{
  .tab-wrapper{
    position: relative;
  }
  .tab-hd{
    margin-top: 30px;
    background-color: #fff;
    // overflow:hidden;
    height: 40px;
    border-bottom: 1px solid #e5e5e5;
    li{
      position: relative;
      width: 140px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      color: #333;
      cursor: pointer;
      float: left;
      &:before{
        content: "";
        position: absolute;
        left: 50%;
        top: -1px;
        width:0;
        transform:translate(-50%);
        height: 2px;
        background-color: #f75959;
      }
      &.on{
        position: relative;
        color: #f75959;
        border: 1px solid #e5e5e5;
        border-bottom-color: #fff;
        z-index: 3;
        // background-color: #f8f8f8;
        &:before{
          width:100%;
          transition:all 0.3s linear;
        }
      }
    }
  }
  .btn-group{
    position: absolute;
    right: 0;
    top: 0;
    .btn-text{
      margin-left: 20px;
      font-size: 14px;
      color: #999;
      line-height: 40px;
      cursor: pointer;
      &:hover{
        color: #f75959;
      }
    }
  }
  .coupon-wrwapper{
    position: relative;
    margin-top: 10px;
    padding-top: 26px;
    .btn-rule{
      position: absolute;
      right: 0;
      top: 0;
      font-size: 12px;
      color: #999;
      line-height: 24px;
      cursor: pointer;
      &:hover{
        color: #f75959;
      }
    }
  }
  .list{
    overflow: hidden;
    >li{
      float: left;
      margin-right: 10px;
      margin-bottom: 10px;
      border-radius: 10px;
      overflow: hidden;
      background-color: #f9f9f9;
      width: 240px;
      height: 280px;
      position: relative;
      &:nth-child(4n){
        margin-right: 0;
      }
    }
    .dt{
      height: 120px;
      padding: 5px 13px;
      background:  url('~@/assets/coupon/bg-active.png') no-repeat center top;
      background-size: contain;
      padding-top: 40px;
      .type-name{
        font-size: 12px;
        color: #fff;
        line-height: 20px;
        text-align: left;
        position: absolute;
        left: 10px;
        top: 5px;
      }
      .count{
        text-align: center;
        font-size: 48px;
        line-height: 48px;
        color: #fff;
        font-weight: bold;
        font-family: "DIN-Regular";
      }
      .desc{
        text-align: center;
        font-size: 18px;
        color: #fff;
        line-height: 20px;
      }
      .expire{
        position: absolute;
        right: -33px;
        top: -23px;
        font-size: 12px;
        color: #fff;
        line-height: 104px;
        text-align: center;
        width: 80px;
        height: 60px;
        background-color: #00B4FF;
        white-space: nowrap;
        transform: rotate(45deg);
      }
    }
    .dd{
      height: 160px;
      padding: 15px;
      .title{
        font-size: 18px;
        color: #333;
        line-height: 30px;
        font-weight: bold;
      }
      .time{
        display: block;
        font-size: 16px;
        line-height: 24px;
        color: #999;
        margin-top: 6px;
      }
      .mark{
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
        padding: 0 5px;
        height: 18px;
        line-height: 18px;
        font-size: 12px;
        color: #fff;
        background-color: #F5A720;
        margin-left: 8px;
        border-radius: 18px;
      }
      .btn-default{
        float: none;
        display: block;
        width: 100px;
        height: 30px;
        text-align: center;
        font-size: 14px;
        margin: 20px auto 10px;
        border-radius: 2px;
      }
    }
  }
}
</style>